<template>
    <div>
        <div class="main-container">
            <KidHeader :profileId="profileId" :serialNumber="serialNumber" />
            <div class="profile-section" style="border-bottom: unset;">
                <div>
                    <span class="pl-3 header-font"><b>Apps</b></span>
                    <div class="float-right pr-3">
                        <span v-if="deviceDetail && deviceDetail.profile_id">{{ deviceDetail.profile_id.profile_name }}</span><br>
                        <small class="device-name" v-if="deviceDetail">{{ deviceDetail.hardwareInfo.brand }} {{ deviceDetail.hardwareInfo.model }}</small>
                    </div>
                </div>
            </div>
            <div class="profile-section" style="border-bottom: unset;">
                <div class="pl-3 pr-3">
                    <div class="input-group mb-3 has-search">
                        <span class="fa fa-search form-control-feedback"></span>
                        <input type="text" class="form-control" @keyup.enter="getPlayStore('Terms')" placeholder="Search" v-model="playstoreText">
                        <!--<div class="input-group-prepend">
                            <button class="btn btn-outline-secondary" :disabled="isDisabled" @click="getPlayStore('Terms')"><i class="fas fa-search"></i> <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span></button>
                        </div>-->
                    </div>
                </div>
            </div>
            <div class="profile-section ScrollStyle" style="border-bottom: unset;white-space:nowrap;">
                <div class="pl-3 pr-3" :style="{ display: 'block ruby' }">
                    <button type="button" class="btn btn-secondary mr-2" :class="{ 'focus': ageFilter }" style="background-color: #F2F2F2; color: #333333;padding:0.250rem .75rem;border:unset;" data-toggle="collapse" data-target="#sortByPopup" aria-controls="sortByPopup" aria-expanded="false" aria-label="Toggle navigation">Age Group
                      <DownArrowIcon /> 
                    </button>
                    <button type="button" class="btn btn-secondary mr-2" :class="{ 'focus': filterCategory }" style="background-color: #F2F2F2; color: #333333;padding:0.250rem .75rem;border:unset;" data-toggle="collapse" data-target="#filterByCategoryPopup" aria-controls="filterByCategoryPopup" aria-expanded="false" aria-label="Toggle navigation">Category 
                      <DownArrowIcon /> 
                    </button>
                    <button type="button" class="btn btn-secondary mr-2" :class="{ 'focus': expertRatingFilter }" style="background-color: #F2F2F2; color: #333333;padding:0.250rem .75rem;border:unset;" data-toggle="collapse" data-target="#expertRatingPopup" aria-controls="sortByPopup" aria-expanded="false" aria-label="Toggle navigation">Expert Rating
                      <DownArrowIcon /> 
                    </button>
                </div>
                <div class="collapse m-2 footer" id="sortByPopup">
                    <div class="card">
                        <div class="card-body">
                            <p class="text-muted"><b>Choose Age</b> <a href="javascript:void(0)" class="text-black" @click="closePopUp()">
                              <CrossCloseIcon class="float-right pt-1 pr-2" /></a></p>
                            <div class="m-2">
                                <div class="row p-2">
                                    <div class="col-xs-3 pr-2">
                                        <div class="btn-group-toggle" data-toggle="buttons">
                                            <label class="btn btn-secondary-custom" :class="{ 'active': ageFilter == 'AGE_RANGE1' }">
                                              <input type="radio"  v-model="ageFilter" :checked="ageFilter == 'AGE_RANGE1'"  value="AGE_RANGE1" >Under 5
                                            </label>
                                          </div>
                                    </div>
                                    <div class="col-xs-3 pr-2">
                                        <div class="btn-group-toggle" data-toggle="buttons">
                                            <label class="btn btn-secondary-custom" :class="{ 'active': ageFilter == 'AGE_RANGE2' }">
                                              <input type="radio" v-model="ageFilter" :checked="ageFilter == 'AGE_RANGE2'" value="AGE_RANGE2" >6-8
                                            </label>
                                          </div>
                                    </div>
                                    <div class="col-xs-3 pr-2">
                                        <div class="btn-group-toggle" data-toggle="buttons">
                                            <label class="btn btn-secondary-custom" :class="{ 'active': ageFilter == 'AGE_RANGE3' }">
                                              <input type="radio" v-model="ageFilter" :checked="ageFilter == 'AGE_RANGE3'" value="AGE_RANGE3" >9 Up
                                            </label>
                                          </div>
                                    </div>
                                </div>
                                <div class="row p-2">
                                  <div class="col-xs-3 pr-2">
                                        <div class="btn-group-toggle" data-toggle="buttons">
                                            <label class="btn btn-secondary-custom" :class="{ 'active': ageFilter == 'AGE_RANGE_ALL' }">
                                              <input type="radio" v-model="ageFilter" :checked="ageFilter == 'AGE_RANGE_ALL'" value="AGE_RANGE_ALL" >All ages up to 12
                                            </label>
                                          </div>
                                  </div>
                                </div>
                                <div class="border-top pt-3">
                                    <a href="javascript:void(0)" @click="clearAgeFilter()">Clear</a>
                                    <button type="button" class="btn btn-primary float-right" @click="getPlayStore('Age')">Apply</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="collapse m-2 footer" id="filterByCategoryPopup">
                    <div class="card">
                        <div class="card-body">
                            <p class="text-muted"><b>Choose Categories</b> <a href="javascript:void(0)" class="text-black" @click="closePopUp()"><CrossCloseIcon class="float-right pt-1 pr-2" /></a></p>
                            <div class="m-2" :style="{ 'overflow-y': 'auto', 'height': '450px' }">
                                <table class="table">
                                  <tbody>
                                    <tr v-for="parentCat in playStoreCategories" :key="parentCat">
                                      <td v-for="category in parentCat" :key="category" :style="{'border-top': 'unset', 'padding': '0.25rem'}">
                                        <div class="btn-group-toggle" data-toggle="buttons">
                                            <label class="btn btn-secondary-custom" :class="{ 'active': filterCategory == category }" :style="{ 'font-size': '12px', 'text-transform': 'lowercase', 'width': '100%' }">
                                              <input type="radio"  v-model="filterCategory" :value="category" >
                                              {{ category.replace(/_/g, ' ') }}
                                            </label>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <!--<div class="row p-2" v-for="parentCat in playStoreCategories" :key="parentCat">
                                    <div class="col-xs-6 pr-2" v-for="category in parentCat" :key="category">
                                        <div class="btn-group-toggle ml-4" data-toggle="buttons">
                                            <label class="btn btn-secondary-custom" :style="{ 'font-size': '12px', 'text-transform': 'lowercase' }">
                                              <input type="checkbox" name="filterCategory" v-model="filterCategory" :true-value="category" false-value="" >
                                              {{ category.replace(/_/g, ' ') }}
                                            </label>
                                        </div>
                                    </div>
                                </div>-->
                            </div>
                            <div class="border-top pt-3">
                                <a href="javascript:void(0)" @click="clearCategoryFilter()">Clear</a>
                                <button type="button" class="btn btn-primary float-right" @click="getPlayStore('Category')">Apply</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="collapse m-2 footer" id="expertRatingPopup">
                    <div class="card">
                        <div class="card-body">
                            <p class="text-muted"><b>Choose Expert Rating</b> <a href="javascript:void(0)" class="text-black" @click="closePopUp()"><CrossCloseIcon class="float-right pt-1 pr-2" /></a></p>
                            <div class="m-2">
                                <div class="row p-2">
                                  <div class="col-xs-3 pr-2">
                                      <div class="btn-group-toggle" data-toggle="buttons">
                                        <label class="btn btn-secondary-custom label-custom-filter font-14" :class="{ 'active': expertRatingFilter == 'EXPERT_RECOMMENDATION' }">
                                          <input type="radio" v-model="expertRatingFilter" :checked="expertRatingFilter == 'EXPERT_RECOMMENDATION'" value="EXPERT_RECOMMENDATION" >
                                           Recommended &nbsp;
                                        </label>
                                      </div>
                                  </div>
                                </div>
                                <div class="row p-2">
                                  <div class="col-xs-3 pr-2">
                                      <div class="btn-group-toggle" data-toggle="buttons">
                                        <label class="btn btn-secondary-custom label-custom-filter font-14" :class="{ 'active': expertRatingFilter == 'PARENTAL_SUPERVISION' }">
                                          <input type="radio" v-model="expertRatingFilter" :checked="expertRatingFilter == 'PARENTAL_SUPERVISION'" value="PARENTAL_SUPERVISION" >
                                          Recommended with parental supervision &nbsp;
                                        </label>
                                      </div>
                                  </div>
                                </div>
                                <!--<div class="row p-2">
                                  <div class="col-xs-3 pr-2">
                                      <div class="btn-group-toggle" data-toggle="buttons">
                                        <label class="btn btn-secondary-custom label-custom-filter font-14" :class="{ 'active': expertRatingFilter == 'NOT_RATED' }">
                                          <input type="radio" v-model="expertRatingFilter" :checked="expertRatingFilter == 'NOT_RATED'" value="NOT_RATED" >
                                          &nbsp;
                                          <img :src="notRated" height="auto" width="60px"/> Not Certified Yet&nbsp;
                                        </label>
                                      </div>
                                  </div>
                                </div>-->
                                <div class="border-top pt-3">
                                    <a href="javascript:void(0)" @click="clearExpertRatingFilter()">Clear</a>
                                    <button type="button" class="btn btn-primary float-right" @click="getPlayStore('ExpertRating')">Apply</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="profile-section" style="border-bottom: unset;">
                <div class="pl-3 pr-3">
                    <div class="nav nav-pills" role="tablist">
                      <a class="nav-link active" href="#installedApps" role="tab" data-toggle="tab"><b>Installed</b></a>
                        <a class="nav-link" href="#playstore" role="tab" data-toggle="tab" id="all"><b>Search Result</b></a>
                    </div>
                    <hr :style="{ margin: 'unset' }">
                    <div class="tab-content p-2">
                        <div class="tab-pane" id="playstore">
                            <h5 class="pb-2" :style="{ 'font-size': '18px' }"><b>{{ playstoreLabel }}</b></h5>
                            <div class="row justify-content-center" v-if="showLoader == true">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div class="row border-bottom app-list" v-for="application in playStoreApplications" :key="application._id">
                                <div class="col-3 align-items-center pt-1" v-if="!hiddenPackages.includes(application.appId)">
                                    <a href="javascript:void(0)" class="text-app-list" @click="$router.push({ path: '/application', query: { package_name: application.appId, profile_id: this.profileId, serialNumber: this.serialNumber, playstoreText: this.playstoreText, filterCategory: this.filterCategory, ageFilter: this.ageFilter, expertRatingFilter: this.expertRatingFilter } })">
                                      <img :src="application.icon" style="height: 70px; width: 70px;;border-radius: 15px;">
                                    </a>
                                </div>
                                <div class="col-9 pl-2 align-items-center" v-if="!hiddenPackages.includes(application.appId)">
                                    <span><a href="javascript:void(0)" class="text-app-list" @click="$router.push({ path: '/application', query: { package_name: application.appId, profile_id: this.profileId, serialNumber: this.serialNumber, playstoreText: this.playstoreText, filterCategory: this.filterCategory, ageFilter: this.ageFilter, expertRatingFilter: this.expertRatingFilter } })">{{ application.title }}</a></span><br>
                                    <div>
                                        <label v-if="application.expertRating == 'EXPERT_RECOMMENDATION'">
                                          <img :src="exportGreen" height="auto" width="17px"/>
                                        </label>
                                        <label v-if="application.expertRating == 'PARENTAL_SUPERVISION'">
                                          <img :src="exportOrange" height="auto" width="17px"/>
                                        </label>
                                        <label v-if="application.expertRating == '16+'">
                                          <img :src="sixteenPlus" height="auto" width="17px"/>
                                        </label>
                                        <label v-if="application.expertRating == ''">
                                          <img :src="notRated" height="auto" width="17px"/>
                                        </label>
                                        <span class="pl-4">
                                          <i class="fas fa-star" style="color: gold;"></i> {{ application.scoreText }} </span>
                                        <span class="pl-4">
                                          <img :style="{'margin-bottom':'2px'}" v-if="application.kidsRating.avgKidsRating >= 3" :src="childPositiveSmile" />
                                          <img class="mb-1" v-else-if="application.kidsRating.avgKidsRating >= 2 && application.kidsRating.avgKidsRating < 3" :src="childNeutralSmile" />
                                          <img :style="{'margin-bottom':'2px'}" v-else-if="application.kidsRating.avgKidsRating >= 1 && application.kidsRating.avgKidsRating < 2" :src="childNegativeSmile" />
                                          <i v-else class="far fa-smile rating-grey" />
                                          {{ application.overallRating }}
                                        </span>
                                        <span class="pl-4" v-if="application.price > 0">₣ {{ application.price }}</span>
                                    </div>
                                    <div>
                                        <button type="button" class="float-right mb-2 install-app-btn" v-if="application.free == false && application.isAppInstalled == false" >Coming Soon</button>
                                        <div v-else>
                                          <button type="button" :disabled="isDisabled" class="float-right mb-2 install-app-btn" v-if="application.isAppInstalled == false" @click="openDailyLimitSetPopup(application)">Install</button>
                                          <a :disabled="isDisabled" class="float-right mb-2" v-else @click="uninstallProfileApplication(application.appId)" href="javascript:void(0)">
                                            <TrashIcon /> 
                                              <i v-if="isDisabled" class="fa fa-spinner fa-spin"></i>
                                          </a>
                                        </div>
                                    </div>
                                    <div class="social-app-warning" v-if="socialMediaPackages.includes(application.appId)" >
                                      ⚠️This app is not recommended for children. Social media apps can be addictive and may expose kids to inappropriate content. 
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane active" id="installedApps">
                          <div class="row border-bottom app-list" v-for="application in installedApplicationList" :key="application._id">
                            
                            <!-- App Icon -->
                            <div class="col-3 align-items-center pt-1" :style="{ opacity: application.is_app_disabled ? 0.2 : 1 }">
                              <a href="javascript:void(0)" class="text-app-list" 
                                @click="$router.push({ path: '/application', query: { package_name: application.package_name, profile_id: this.profileId, serialNumber: this.serialNumber, playstoreText: this.playstoreText, filterCategory: this.filterCategory, ageFilter: this.ageFilter, expertRatingFilter: this.expertRatingFilter } })">
                                <img :src="application.app_icon" style="height: 70px; width: 70px; border-radius: 15px;">
                              </a>
                            </div>

                            <!-- App Details -->
                            <div class="col-9 pl-2 align-items-center">
                              
                              <!-- App Name -->
                              <span>
                                <a href="javascript:void(0)" class="text-app-list"
                                  @click="$router.push({ path: '/application', query: { package_name: application.package_name, profile_id: this.profileId, serialNumber: this.serialNumber, playstoreText: this.playstoreText, filterCategory: this.filterCategory, ageFilter: this.ageFilter, expertRatingFilter: this.expertRatingFilter } })">
                                  {{ getAppTitle(application.display_text) }}
                                </a>
                                <a :style="{ 'text-decoration': 'unset' }"
                                  v-if="application.installationFailureReason"
                                  href="javascript:void(0)"
                                  @click="openAppInstallationErrorPopup(application.installationFailureReason)">
                                  &nbsp; <i class="fas fa-exclamation-circle text-danger"></i>
                                </a>
                              </span>

                              <!-- App disabled reason -->
                              <div v-if="application.is_app_disabled" class="text-danger small mt-1">
                                Disabled
                                <span v-if="application.appEnabledDisabledType">
                                  ({{ getReasonText(application.appEnabledDisabledType) }})
                                </span>
                              </div>

                              <!-- Ratings -->
                              <div :style="{ opacity: application.is_app_disabled ? 0.5 : 1 }">
                                <label v-if="application.expertRating == 'EXPERT_RECOMMENDATION'">
                                  <img :src="exportGreen" height="auto" width="17px"/>
                                </label>
                                <label v-if="application.expertRating == 'PARENTAL_SUPERVISION'">
                                  <img :src="exportOrange" height="auto" width="17px"/>
                                </label>
                                <label v-if="application.expertRating == '16+'">
                                  <img :src="sixteenPlus" height="auto" width="17px"/>
                                </label>
                                <label v-if="application.expertRating == ''">
                                  <img :src="notRated" height="auto" width="17px"/>
                                </label>
                                <span class="pl-4" v-if="application.playstoreDetail">
                                  <i class="fas fa-star" style="color: gold;"></i> 
                                  {{ application.playstoreDetail.scoreText }}
                                </span>
                                <span class="pl-4" v-else>
                                  <i class="fas fa-star" style="color: gold;"></i> 0.0
                                </span>
                                <span class="pl-4">
                                  <img :style="{'margin-bottom':'3px'}" 
                                      v-if="application.kidsRating.avgKidsRating >= 3" 
                                      :src="childPositiveSmile" />
                                  <img class="mb-1" 
                                      v-else-if="application.kidsRating.avgKidsRating >= 2 && application.kidsRating.avgKidsRating < 3" 
                                      :src="childNeutralSmile" />
                                  <img :style="{'margin-bottom':'2px'}" 
                                      v-else-if="application.kidsRating.avgKidsRating >= 1 && application.kidsRating.avgKidsRating < 2" 
                                      :src="childNegativeSmile" />
                                  <i v-else class="far fa-smile rating-grey" />
                                  {{ application.overallRating }}
                                </span>
                              </div>

                              <!-- Daily Limit Progress -->
                              <div v-if="application.enableDailyLimit" class="mt-2 mb-1">
                                <div class="d-flex justify-content-between small">
                                  <span>Daily Limit: {{ application.dailyLimitTime }}</span>
                                  <span>Used: {{ application.usedLimit }}</span>
                                </div>
                                <div class="progress" style="height: 6px;">
                                  <div 
                                    class="progress-bar" 
                                    role="progressbar"
                                    :class="(application.usedLimitNumber / application.dailyLimitTimeNumber * 100) >= 100 ? 'bg-danger' : 'bg-success'"
                                    :style="{ width: Math.min((application.usedLimitNumber / application.dailyLimitTimeNumber * 100), 100) + '%' }"
                                    :aria-valuenow="application.usedLimitNumber"
                                    :aria-valuemin="0"
                                    :aria-valuemax="application.dailyLimitTimeNumber">
                                  </div>
                                </div>
                              </div>


                              <!-- Action -->
                              <div v-if="application.isSystemApp == false">
                                <a class="float-right mb-2" @click="uninstallProfileApplication(application.package_name)" href="javascript:void(0)">
                                  <TrashIcon/>
                                  <i v-if="isDisabled" class="fa fa-spinner fa-spin"></i>
                                </a>
                              </div>
                              <div class="system-app-warning" v-else>
                                ⚠️ This is a system app and cannot be uninstalled.
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="collapse m-2 footer" id="appInstallationFailurPopup">
                <div class="card">
                    <div class="card-body">
                        <h6 class="text-black">
                            <b>App Installation Status</b> <a href="javascript:void(0)" class="text-black" @click="closeAppInstallationErrorPopup()"><CrossCloseIcon class="float-right pt-1 pr-2" /></a></h6>
                        <hr>
                        <p>{{ appInstallaionErrors[installationFailureReason] }}</p>
                    </div>
                </div>
            </div>
            <div class="collapse footer" id="dailyLimitSetPopup">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex justify-content-between align-items-start">
                      <h6 class="text-black mb-0">
                        <b v-if="app">Daily Limit Configuration for {{ app.title }}</b>
                      </h6>
                      <a href="javascript:void(0)" class="text-black" @click="closeDailyLimitSetPopup()">
                        <CrossCloseIcon class="pt-1" />
                      </a>
                    </div>
                    <hr>

                    <p class="text-black">
                      By setting a daily limit, you can ensure that your child is unable to use the app once the assigned time has been reached. The app will automatically be disabled once the daily limit is exceeded, promoting healthy usage habits.
                    </p>

                    <!-- Toggle Section -->
                    <div class="profile-section mb-3">
                      <p class="text-black mb-1">
                        <b>Daily Limit</b> - <small>In Minute</small>
                      </p>
                      <div class="card w-100 bg-light">
                        <div class="card-body d-flex justify-content-between align-items-center p-2">
                          <span style="font-size: 15px;">Enabled daily limit</span>
                          <label class="switch mb-0">
                            <input type="checkbox" v-model="enableDailyLimit">
                            <span class="slider round"></span>
                          </label>
                        </div>
                      </div>
                    </div>

                    <!-- Input Control Section -->
                    <div class="mb-4">
                      <label class="d-block">Daily limit</label>
                      <div class="input-group mx-auto" style="border: 1px solid #dee2e6;">
                        <div class="input-group-prepend">
                          <div class="input-group-text bg-white border-0">
                            <a class="text-black" href="javascript:void(0)" @click="decreaseLimit()">
                              <ArrowLeftIcon />
                            </a>
                          </div>
                        </div>
                        <input type="text"
                              class="form-control text-black text-center font-weight-bold border-0"
                              :disabled="!enableDailyLimit"
                              v-model="dailyLimitTime"
                              @blur="roundOF15()" />
                        <div class="input-group-prepend">
                          <div class="input-group-text bg-white border-0">
                            <a class="text-black" href="javascript:void(0)" @click="increaseLimit()">
                              <ArrowRightIcon />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Buttons -->
                    <div class="text-center">
                      <button type="button"
                              class="btn btn-primary btn-block mb-2"
                              style="border-radius: 20px; background: #0073EE;"
                              @click="saveAppDailyLimit()"
                              :disabled="isDisabled || dailyLimitTime <= 0">
                        Install (Time Limit)
                        <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
                      </button>
                      <button type="button"
                              class="btn btn-warning btn-block"
                              style="border-radius: 20px;"
                              @click="saveAppDailyLimit(true)"
                              :disabled="isDisabled">
                        Install (No Time Limit)
                        <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
                      </button>
                    </div>
                  </div>
                </div>

            </div>
            <div class="profile-section text-center pt-2">
                  Last Update: {{ lastUpdated }}
            </div>
            <KidFooter :profileId="profileId" :serialNumber="serialNumber" />
        </div>
    </div>
</template>
<script>
const SYSTEM_APP_TITLE_MAP = {
  'com.samsung.android.incallui': 'Phone',
  'com.samsung.android.dialer': 'Phone',
  'com.android.settings': 'Settings',
  'com.android.vending': 'Google Play Store',
  'com.sec.android.gallery3d': 'Gallery',
  'com.sec.android.app.camera': 'Camera',
  'com.samsung.android.app.contacts': 'Contacts',
  'com.wingio.hwbview': 'Android WebView'
};

import KidHeader from '@/components/KidHeader.vue'
import ProfileService from "../../services/ProfileService";
import KidsService from "../../services/KidsService";
import KidFooter from '@/components/KidFooter.vue'
import DownArrowIcon from '@/components/icons/DownArrowIcon.vue'
import TrashIcon from '@/components/icons/TrashIcon.vue'
import ArrowLeftIcon from '@/components/icons/ArrowLeftIcon.vue'
import ArrowRightIcon from '@/components/icons/ArrowRightIcon.vue'
import ArrowLeftBackIcon from '@/components/icons/ArrowLeftBackIcon.vue'
import CrossCloseIcon from '@/components/icons/CrossCloseIcon.vue'
import StarGoldIcon from '@/components/icons/StarGoldIcon.vue'

export default {
  name: 'Play Store',
  components: {
    KidHeader,
    KidFooter,
    DownArrowIcon,
    TrashIcon,
    ArrowRightIcon,
    ArrowLeftIcon,
    ArrowLeftBackIcon,
    CrossCloseIcon,
    StarGoldIcon
  },
  props: {
    notRated: {
        type: String,
        default: "./images/not-certified.png",
    },
    exportOrange: {
        type: String,
        default: "./images/experts-orange.png",
    },
    exportGreen: {
        type: String,
        default: "./images/experts-green.png",
    },
    sixteenPlus: {
        type: String,
        default: "./images/16-plus.png",
    },
    childPositiveSmile: {
        type: String,
        default: "./images/child-positive-smile.png",
    },
    childNeutralSmile:{
        type: String,
        default: "./images/child-neutral-smile.png",
    },
    childNegativeSmile:{
        type: String,
        default: "./images/child-negative-smile.png",
    },
  },
  data() {
    return {
        showLoader: false,
        isDisabled: false,
        installedApplicationList: [],
        profileId: this.$route.query.profileId,
        serialNumber: this.$route.query.serialNumber,
        playstoreText: this.$route.query.playstoreText,
        playStoreApplications: [],
        deviceDetail: null,
        ageFilter: this.$route.query.ageFilter,
        filterCategory:this.$route.query.filterCategory,
        expertRatingFilter: this.$route.query.expertRatingFilter,
        playStoreCategories: [],
        playstoreLabel:"No data found",
        lastUpdated: "No data found.",
        installationFailureReason: "",
        appInstallaionErrors : {"INSTALLATION_FAILURE_REASON_UNKNOWN":"An unknown condition is preventing the app from being installed. Some potential reasons are that the device doesn't have enough storage, the device network connection is unreliable, or the installation is taking longer than expected. The installation will be retried automatically.",
        "IN_PROGRESS":"The installation is still in progress.", "NOT_FOUND":"The app was not found in Play.", "NOT_COMPATIBLE_WITH_DEVICE":"The app is incompatible with the device,",
        "NOT_APPROVED":"The app has not been approved by the admin.","PERMISSIONS_NOT_ACCEPTED":"The app has new permissions that have not been accepted by the admin.",
        "NOT_AVAILABLE_IN_COUNTRY	":"The app is not available in the user's country.", "NO_LICENSES_REMAINING":"There are no licenses available to assign to the user.",
        "NOT_ENROLLED":"The enterprise is no longer enrolled with Managed Google Play or the admin has not accepted the latest Managed Google Play Terms of Service.",
        "USER_INVALID":"The user is no longer valid. The user may have been deleted or disabled.",
        "NETWORK_ERROR_UNRELIABLE_CONNECTION":"A network error on the user's device has prevented the install from succeeding. This usually happens when the device's internet connectivity is degraded, unavailable or there's a network configuration issue. Please ensure the device has access to full internet connectivity on a network that meets Android Enterprise Network Requirements. App install or update will automatically resume once this is the case.",
        "INSUFFICIENT_STORAGE":"The user's device does not have sufficient storage space to install the app. This can be resolved by clearing up storage space on the device. App install or update will automatically resume once the device has sufficient storage."},
        //hiddenPackages: ['com.nova.kidsfirstphone','com.facebook.katana','com.twitter.android','com.instagram.android','com.linkedin.android','com.zhiliaoapp.musically','com.pinterest','com.snapchat.android','com.instagram.barcelona','com.google.android.youtube', 'com.facebook.lite', 'com.facebook.pages.app', 'com.facebook.work', 'com.instagram.android', 'com.facebook.adsmanager', 'com.facebook.workchat', 'com.facebook.orca', 'com.instagram.lite', 'org.telegram.messenger', 'com.discord', 'com.twitter.android'],
        hiddenPackages: [],
        socialMediaPackages: ['com.nova.kidsfirstphone','com.facebook.katana','com.facebook.lite','com.facebook.orca','com.facebook.mlite','com.facebook.pages.app','com.instagram.android','com.instagram.lite','com.instagram.barcelona','com.twitter.android','com.twitter.android.lite','com.zhiliaoapp.musically','com.zhiliaoapp.musically.go','com.snapchat.android','org.telegram.messenger','org.telegram.messenger.web','org.telegram.messenger.beta','com.reddit.frontpage','com.linkedin.android','com.pinterest','com.discord','com.skype.raider','com.viber.voip','com.tumblr','com.bigo.live','com.yubo.application','co.yellw.yubo','com.weheartit','com.wattpad','com.quora.android','com.clubhouse.app','com.tmtg.apps.truthsocial','com.bereal.ft','com.vkontakte.android','com.jappy.android','video.like','com.kik.android','com.houseparty','com.whisper','com.monkey','com.look.app','com.yikyak','com.youown.yo','com.meetme','com.omegle','com.tinder','com.bumble','com.afterfocus.app','com.sarahah.app','com.yoowolf.app'],
        enableDailyLimit: true,
        dailyLimitTime: 60,
        app: null,
    }
  },
  methods: {
    getAppTitle(appName) {
      return SYSTEM_APP_TITLE_MAP[appName] || appName;
    },
    getDeviceProfileApplicationList() {
      let data = {
        profile_id: this.profileId,
        install_type: "FORCE_INSTALLED",
        serialNumber: this.serialNumber
      }
      ProfileService.getDeviceProfileApplicationList(data)
        .then((response) => {
          this.installedApplicationList = response.data.data;
        })
        .catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    async getPlayStore(currentFilter = null) {
      this.showLoader = true;
      $('#sortByPopup').collapse('hide');
      $('#filterByCategoryPopup').collapse('hide');
      $('#expertRatingPopup').collapse('hide');
        if (currentFilter == "Terms") {
          this.ageFilter = "";
          this.filterCategory = "";
          this.expertRatingFilter = "";
        } else if (currentFilter == "Age") {
          this.filterCategory = "";
          this.playstoreText = "";
          this.expertRatingFilter = "";
        } else if (currentFilter == "Category") {
          this.playstoreText = "";
          this.ageFilter = "";
          this.expertRatingFilter = "";
        }
        this.isDisabled = true;
        let data = {
            profileId: this.profileId,
            serialNumber: this.serialNumber,
            playstoreText: this.playstoreText,
            ageFilter: this.ageFilter,
            filterCategory: this.filterCategory,
            expertRatingFilter: this.expertRatingFilter
        }
        if(this.ageFilter) {
            if ($("#all").length > 0) {
              $("#all")[0].click();
            }
            if (this.ageFilter == "AGE_RANGE1") {
              this.playstoreLabel = "Show result for Ages up to 5";
            } else if (this.ageFilter == "AGE_RANGE2") {
              this.playstoreLabel = "Show result for Ages 6-8";
            } else if (this.ageFilter == "AGE_RANGE3") {
              this.playstoreLabel = "Show result for Ages 9-12";
            } else {
              this.playstoreLabel = "Show result for All ages up to 12";
            }
            this.filterCategory = "";
        } else if(this.filterCategory) {
            if ($("#all").length > 0) {
              $("#all")[0].click();
            }
            this.playstoreLabel = "Show result for " + this.filterCategory.replace(/_/g, ' ') + " Category";
        } else if (this.playstoreText) {
          this.playstoreLabel = "Show result for " + this.playstoreText;
          if ($("#all").length > 0) {
              $("#all")[0].click();
          }
        } else if (this.expertRatingFilter) {
          let lable = (this.expertRatingFilter == "EXPERT_RECOMMENDATION") ? "Expert Recommendation" : "Expert Recommendation With Parental Supervision"
          if (this.expertRatingFilter == "NOT_RATED") {
            lable = "Not Certified"
          }
          this.playstoreLabel = "Show result for " + lable;
          if ($("#all").length > 0) {
            $("#all")[0].click();
          }
        }  else {
          this.playstoreLabel = "No data found"
        } 
        
        this.playStoreApplications = [];
        await KidsService.getPlayStore(data)
            .then((response) => {
                this.showLoader = false;
                //this.filterCategory = "";
                this.playStoreApplications = [];
                this.isDisabled = false;
                this.playStoreApplications = response.data.data
                this.deviceDetail = response.data.deviceDetail;
                if (this.deviceDetail && this.deviceDetail.lastDeviceActivationDate) {
                    this.lastUpdated = new Date(this.deviceDetail.lastDeviceActivationDate).toLocaleDateString("en-US", this.$dateOptions) + " " + new Date(this.deviceDetail.lastDeviceActivationDate).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
                } else {
                    this.lastUpdated = "No data found.";
                }
            })
            .catch((e) => {
                this.showLoader = false;
                this.playStoreApplications = [];
                this.isDisabled = false;
                this.$toast.error(e);
            });
    },
    closePopUp() {
      $('#sortByPopup').collapse('hide');
      $('#filterByCategoryPopup').collapse('hide');
      $('#expertRatingPopup').collapse('hide');
    },
    async clearExpertRatingFilter() {
      this.expertRatingFilter = "";
      await this.getPlayStore();
      $('#expertRatingPopup').collapse('hide');
    },
    async clearAgeFilter() {
      this.ageFilter = "";
      await this.getPlayStore();
      $('#sortByPopup').collapse('hide');
    },
    async clearCategoryFilter() {
      this.filterCategory = "";
      await this.getPlayStore();
      $('#filterByCategoryPopup').collapse('hide');
    },
    async createProfileApplication(app, skipDailyConfiguration = false) {
        this.isDisabled = true;
        let masterApplicationData = {
            product_id: app.appId,
            package_name: app.appId,
            app_icon: app.icon,
            application_details: app,
            type: this.deviceDetail &&
            this.deviceDetail.profile_id &&
            this.deviceDetail.profile_id.profile_type === "Ios"
              ? "Ios"
              : "Android"
        };
        await ProfileService.createMasterApplication(masterApplicationData)
        .then((response) => {
        }).catch((e) => {
        })

      let data = {
        profile_id: this.profileId,
        package_name: app.appId,
        is_web_app: false,
        application_details: app,
        type: this.deviceDetail &&
            this.deviceDetail.profile_id &&
            this.deviceDetail.profile_id.profile_type === "Ios"
              ? "Ios"
              : "Android",
        serialNumber: this.serialNumber,
        enableDailyLimit: (skipDailyConfiguration == true) ? false : this.enableDailyLimit,
        dailyLimitTime: (skipDailyConfiguration == true) ? 0 : this.dailyLimitTime
      };

      await ProfileService.createProfileApplication(data)
        .then((response) => {
            let profileType = this.deviceDetail &&
              this.deviceDetail.profile_id &&
              this.deviceDetail.profile_id.profile_type === "Ios"
                ? "Ios"
                : "Android"
            if (profileType == "Ios") {
               this.iosApplyPolicy();
            } else {
               this.applyPolicy();
            }
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
            this.enableDailyLimit = true;
            this.dailyLimitTime = 60;
            $('#dailyLimitSetPopup').collapse('hide')
            this.getPlayStore();
            this.getDeviceProfileApplicationList();
        })
        .catch((e) => {
            this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    async uninstallProfileApplication(package_name) {
      this.isDisabled = true;
      var data = {
        package_name: package_name,
        profile_id: this.profileId,
        serialNumber: this.serialNumber
      };

      await ProfileService.uninstallProfileApplication(data)
        .then(async (response) => {
            let profileType = this.deviceDetail &&
              this.deviceDetail.profile_id &&
              this.deviceDetail.profile_id.profile_type === "Ios"
                ? "Ios"
                : "Android"
            if (profileType == "Ios") {
               this.iosApplyPolicy();
            } else {
              await this.applyPolicy();
            }
            this.deleteProfileApplication(package_name);
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
          this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    deleteProfileApplication(package_name) {
        this.isDisabled = true;
        var data = {
          package_name: package_name,
          profile_id: this.profileId,
          serialNumber: this.serialNumber
        };

        ProfileService.deleteProfileApplication(data)
        .then((response) => {
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
            this.getPlayStore();
            this.getDeviceProfileApplicationList();
        })
        .catch((e) => {
          this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },

    iosApplyPolicy() {
          this.isDisabled = true;
          let data = {
            profile_id: this.profileId,
          }
          ProfileService.iosApplyPolicy(data)
          .then((response) => {
            this.$toast.success(response.data.respones_msg);
            this.isDisabled = false;
          }).catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
            this.isDisabled = false;
            /*if (e.response.data.data.payment_redirection) {
              this.$router.push({ path: 'plan-list'})
            }*/
          });
    },
    async applyPolicy() {
      this.isDisabled = true;
      let data = {
        profile_id: this.profileId,
        serialNumber: this.serialNumber
      };

      await ProfileService.applyPolicy(data)
        .then((response) => {
          this.isDisabled = false;
          this.$toast.success(response.data.respones_msg);
        })
        .catch((e) => {
          this.isDisabled = false;
          //this.$toast.error(e.response.data.respones_msg);
        });
    },
    openAppInstallationErrorPopup(reason) {
      $('#appInstallationFailurPopup').collapse('show');
      this.installationFailureReason = reason;
    },
    closeAppInstallationErrorPopup() {
      $('#appInstallationFailurPopup').collapse('hide');
      this.installationFailureReason = "";
    },

    async openDailyLimitSetPopup(app) {
        this.app = app,
        $('#dailyLimitSetPopup').collapse('show')
    },
    async saveAppDailyLimit(skipDailyConfiguration) {
        return await this.createProfileApplication(this.app, skipDailyConfiguration);
    },
    closeDailyLimitSetPopup(){
        $('#dailyLimitSetPopup').collapse('hide')
    },
    decreaseLimit() {
        if (this.dailyLimitTime > 0) {
            this.dailyLimitTime = this.dailyLimitTime - 15
        }
    },
    increaseLimit() {
        this.dailyLimitTime = (parseInt(this.dailyLimitTime) + 15)
    },
    roundOF15() {
        this.dailyLimitTime = Math.ceil(this.dailyLimitTime/15.0) * 15;
    },
    getReasonText(type) {
      switch (type) {
        case 'Manually':
          return 'manually';
        case 'Overuse':
          return 'due to app time limit';
        case 'Category Overuse':
          return 'due to category time limit';
        case 'Cronjob':
          return 'via schedule';
        case 'Global Daily Limit Reach':
          return 'due to device time limit';
        default:
          return '';
      }
    }
  },
  watch: {
  },
  beforeMount() {
    this.getPlayStore();
    this.getDeviceProfileApplicationList();

    let array = [
    'ANDROID_WEAR',       'APPLICATION',        'ART_AND_DESIGN',
    'AUTO_AND_VEHICLES',  'BEAUTY',             'BOOKS_AND_REFERENCE',
    'BUSINESS',           'COMICS',             'COMMUNICATION',
    'DATING',             'EDUCATION',          'ENTERTAINMENT',
    'EVENTS',             'FAMILY',             'FINANCE',
    'FOOD_AND_DRINK',     'GAME',               'GAME_ACTION',
    'GAME_ADVENTURE',     'GAME_ARCADE',        'GAME_BOARD',
    'GAME_CARD',          'GAME_CASINO',        'GAME_CASUAL',
    'GAME_EDUCATIONAL',   'GAME_MUSIC',         'GAME_PUZZLE',
    'GAME_RACING',        'GAME_ROLE_PLAYING',  'GAME_SIMULATION',
    'GAME_SPORTS',        'GAME_STRATEGY',      'GAME_TRIVIA',
    'GAME_WORD',          'HEALTH_AND_FITNESS', 'HOUSE_AND_HOME',
    'LIBRARIES_AND_DEMO', 'LIFESTYLE',          'MAPS_AND_NAVIGATION',
    'MEDICAL',            'MUSIC_AND_AUDIO',    'NEWS_AND_MAGAZINES',
    'PARENTING',          'PERSONALIZATION',    'PHOTOGRAPHY',
    'PRODUCTIVITY',       'SHOPPING',           'SOCIAL',
    'SPORTS',             'TOOLS',              'TRAVEL_AND_LOCAL',
    'VIDEO_PLAYERS',      'WATCH_FACE',         'WEATHER'
  ]
    const chunkSize = 3;
    let finalArray = [];
    for (let i = 0; i < array.length; i += chunkSize) {
        const chunk = array.slice(i, i + chunkSize);
        finalArray.push(chunk)
        // do whatever
    }
    this.playStoreCategories = finalArray
  }, 
}
</script>
<style scoped>
.system-app-warning {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeeba;
  padding: 12px 16px;
  border-radius: 6px;
  font-family: Arial, sans-serif;
  font-size: 14px;
  margin-top: 10px;
  display: inline-block;
}
.social-app-warning {
  background-color: #dc3545!important;
  color: #fff!important;
  border: 1px solid #ffeeba;
  padding: 12px 16px;
  border-radius: 6px;
  font-family: Arial, sans-serif;
  font-size: 14px;
  margin-top: 10px;
  display: inline-block;
}
</style>